export default {
  data: {
    name: 'Nombre',
    phone: 'Teléfono',
    fax: 'Fax',
    email: 'Email',
    department: 'Departamento',
    departmentCode: 'Código departamento',
    assignedAccountId: 'Código Cuenta Contable',
    assignedAccountIdTooltip: 'Introduce aquí el código asociado de tu software de contabilidad'

  },
  options: {
    faceB2b: 'DIRe (FACeB2B)',
    faceDir3: 'DIR3 (FACe)',
    noFace: 'Ninguno'
  },
  mandatory: {
    email: 'Si el receptor no pertenece a la plataforma, esta le avisará por email'
  },
  additionalInfo: {
    code: 'Código',
    description: 'Descripción',
    postalCode: 'Código Postal',
    address: 'Direccion',
    street: 'Direccion',
    town: 'Ciudad',
    city: 'Provincia',
    country: 'País',
    name: 'Nombre',
    firstname: 'Primer Apellido',
    lastname: 'Segundo Apellido'
  }
}
